import { Tabs as MantineTabs, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React from 'react';

interface Tab {
    title: string;
    id: string;
    icon?: React.ReactNode;
    body: React.ReactNode;
    disabled?: boolean;
}

interface Props {
    tabs: Tab[];
    defaultId?: string;
}

export default function Tabs({ tabs, defaultId }: Props) {
    const theme = useMantineTheme();
    const largerScreen = useMediaQuery(theme.fn.largerThan('lg').replace('@media ', ''));
    return (
        <div className="w-full">
            <MantineTabs orientation={largerScreen ? 'horizontal' : 'vertical'} defaultValue={defaultId || tabs[0].id}>
                <MantineTabs.List>
                    {tabs.map((tab) => (
                        <MantineTabs.Tab key={tab.id} value={tab.id} icon={tab.icon} disabled={!!tab.disabled}>
                            {tab.title}
                        </MantineTabs.Tab>
                    ))}
                </MantineTabs.List>
                {tabs.map((tab) => (
                    <MantineTabs.Panel key={tab.id} value={tab.id}>
                        {tab.body}
                    </MantineTabs.Panel>
                ))}
            </MantineTabs>
        </div>
    );
}
